var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Enter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2cde7",
    d: "M59,7V57a2,2,0,0,1-2,2H23a2,2,0,0,1-.91-.22A2,2,0,0,1,21,57V7a2,2,0,0,1,2-2H57a2,2,0,0,1,.56.08A2,2,0,0,1,59,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ced9ed",
    d: "M59.56 23.44L59 24 26.22 56.78H22.09A2 2 0 0 1 21 55V48L59 10zM58.38 6.19L21 43.56 21 37 53 5 57.5 5 57.56 5.08 58.38 6.19zM48 5L21 32 21 28 44 5 48 5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#acb7d0",
    d: "M59,58.56h0a1,1,0,0,1-1,1H22a1,1,0,0,1-1-1h0a4,4,0,0,1,4-4H55A4,4,0,0,1,59,58.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#edf0f4",
    d: "M30.5 12L31.74 14.26 34 15.5 31.74 16.74 30.5 19 29.26 16.74 27 15.5 29.26 14.26 30.5 12zM50 40.16L50.85 41.73 52.42 42.58 50.85 43.44 50 45 49.15 43.44 47.58 42.58 49.15 41.73 50 40.16zM30.65 45L31.23 46.06 32.3 46.65 31.23 47.23 30.65 48.3 30.07 47.23 29 46.65 30.07 46.06 30.65 45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M25 52a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V53A1 1 0 0 0 25 52zM30 52a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V53A1 1 0 0 0 30 52zM34 53v2a1 1 0 0 0 2 0V53a1 1 0 0 0-2 0zM40 56a1 1 0 0 0 1-1V53a1 1 0 0 0-2 0v2A1 1 0 0 0 40 56zM45 56a1 1 0 0 0 1-1V53a1 1 0 0 0-2 0v2A1 1 0 0 0 45 56zM50 56a1 1 0 0 0 1-1V53a1 1 0 0 0-2 0v2A1 1 0 0 0 50 56zM55 56a1 1 0 0 0 1-1V53a1 1 0 0 0-2 0v2A1 1 0 0 0 55 56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M60,7a3,3,0,0,0-3-3H23a3,3,0,0,0-3,3V57a3,3,0,0,0,3,3H57a3,3,0,0,0,3-3ZM58,57a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1V7a1,1,0,0,1,1-1H57a1,1,0,0,1,1,1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M7 29L38 29 34 25 38 21 49 32 38 43 34 39 38 35 7 35 7 29z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M49.71,31.29l-11-11a1,1,0,0,0-1.41,0l-4,4a1,1,0,0,0,0,1.41L35.59,28H7a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H35.59l-2.29,2.29a1,1,0,0,0,0,1.41l4,4a1,1,0,0,0,1.41,0l11-11A1,1,0,0,0,49.71,31.29ZM38,41.59,35.41,39l3.29-3.29A1,1,0,0,0,38,34H8V30H38a1,1,0,0,0,.71-1.71L35.41,25,38,22.41,47.59,32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Enter);
export default __webpack_public_path__ + "static/media/icons8-enter.9a84d68cc646e2111b19a0a8a5e88dca.svg";
export { ForwardRef as ReactComponent };